import { Injectable } from '@angular/core'
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router'
import { AlertService } from '../../common/alert/shared/alert.service'
import { OperadorService } from '../services/operador.service'
import { environment } from '../../../environments/environment'
import { BureauService } from '../services/bureau.service'
import { Operador } from '../../pkw-data/core/operador.model'
import { Bureau } from '../../pkw-data/core/bureau.model'

@Injectable()
export class CanActivateColaboradorRouteGuard implements CanActivate {
    constructor(
        private router: Router,
        private operadorService: OperadorService,
        private alertService: AlertService,
        private bureauService: BureauService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let operador: Operador
        this.operadorService.corrente.subscribe((op) => (operador = op))

        let bureau: Bureau
        this.bureauService.corrente.subscribe((b) => (bureau = b))

        let visualizarCollect = operador.hasPermissaoVisualizarCollect()

        let podeAcessar = bureau.userConnection.possuiCollect && visualizarCollect

        if (!podeAcessar) {
            window.location.assign(environment.packupBaseUrl)
        } else if (!operador.isColaborador()) {
            this.alertService.danger(
                'Você tentou acessar uma área restrita. Verifique suas permissões com o administrador do sistema!',
                'Aviso'
            )

            if (visualizarCollect) {
                this.router.navigate(['/'])
            } else {
                window.location.assign(environment.packupBaseUrl)
            }
        }

        return podeAcessar
    }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/can-activate-colaborador-route.guard.ts